// React and hooks
import React from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';

// Screens auth
import LoginScreen from './screens/LoginScreen';

// Layout
import HomeMenu from './screens/HomeMenu';

// General screens
import CategoryScreen from './screens/CategoryScreen';
import BrandScreen from './screens/BrandScreen';
import ProductScreen from './screens/ProductScreen';
import SupplierScreen from './screens/SupplierScreen';
import ClientScreen from './screens/ClientScreen';
import PriceScreen from './screens/PriceScreen';
import Dashboard from './screens/DashboardScreen';
import SalesScreen from './screens/SalesScreen';
import YieldScreen from './screens/YieldScreen'; 
import OrderScreen from './screens/OrderScreen';
import AdminUsersScreen from './screens/AdminUsersScreen';

// Auth helper
import PrivateRoute from './components/PrivateRoute';
import ActionFeedbackProvider from './components/ActionFeedbackProvider';

// Inventory
import PISColdStorage1 from './screens/inventoryscreens/PISColdStorage1';
import PISColdStorage2 from './screens/inventoryscreens/PISColdStorage2';
import PISColdStorage3 from './screens/inventoryscreens/PISColdStorage3';
import PISWarehouse from './screens/inventoryscreens/PISWarehouse';
import PISRefrigerators from './screens/inventoryscreens/PISRefrigerators';
import PISTotems from './screens/inventoryscreens/PISTotems'; 

// Entries
import EntrySColdStorage1 from './screens/entryscreens/EntrySColdStorage1';
import EntrySColdStorage2 from './screens/entryscreens/EntrySColdStorage2';
import EntrySColdStorage3 from './screens/entryscreens/EntrySColdStorage3';
import EntrySRefrigerators from './screens/entryscreens/EntrySRefrigerators';
import EntrySWarehouse from './screens/entryscreens/EntrySWarehouse';
import EntrySTotems from './screens/entryscreens/EntrySTotems'; 

// Exits
import ExitSColdStorage1 from './screens/exitscreens/ExitSColdStorage1';
import ExitSColdStorage2 from './screens/exitscreens/ExitSColdStorage2';
import ExitSColdStorage3 from './screens/exitscreens/ExitSColdStorage3';
import ExitSRefrigerators from './screens/exitscreens/ExitSRefrigerators';
import ExitSWarehouse from './screens/exitscreens/ExitSWarehouse';
import ExitSTotems from './screens/exitscreens/ExitSTotems'; 

function App() {
  const location = useLocation();

  return (
    <ActionFeedbackProvider>
      <Routes location={location}>
        {/* Public routes */}
        <Route path="/login" element={<LoginScreenWrapper />} />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <HomeMenu />
            </PrivateRoute>
          }
        >
          {/* Default dashboard */}
          <Route index element={<Dashboard />} />

          {/* General screens */}
          <Route path="categories" element={<CategoryScreen />} />
          <Route path="brands" element={<BrandScreen />} />
          <Route path="product-templates" element={<ProductScreen />} />
          <Route path="suppliers" element={<SupplierScreen />} />
          <Route path="clients" element={<ClientScreen />} />
          <Route path="prices" element={<PriceScreen />} /> 
          <Route path="sales" element={<SalesScreen />} />
          <Route path="yields" element={<YieldScreen />} /> 
          <Route path="orders" element={<OrderScreen />} />
          <Route path="admin/users" element={<AdminUsersScreen />} />

          {/* Inventory */}
          <Route path="products/inventory/coldstorage1" element={<PISColdStorage1 />} />
          <Route path="products/inventory/coldstorage2" element={<PISColdStorage2 />} />
          <Route path="products/inventory/coldstorage3" element={<PISColdStorage3 />} />
          <Route path="products/inventory/warehouse" element={<PISWarehouse />} />
          <Route path="products/inventory/refrigerators" element={<PISRefrigerators />} />
          <Route path="products/inventory/totems" element={<PISTotems />} />

          {/* Entries */}
          <Route path="coldstorage1/entry" element={<EntrySColdStorage1 />} />
          <Route path="coldstorage2/entry" element={<EntrySColdStorage2 />} />
          <Route path="coldstorage3/entry" element={<EntrySColdStorage3 />} />
          <Route path="refrigerators/entry" element={<EntrySRefrigerators />} />
          <Route path="warehouse/entry" element={<EntrySWarehouse />} />
          <Route path="totems/entry" element={<EntrySTotems />} /> 

          {/* Exits */}
          <Route path="coldstorage1/exit" element={<ExitSColdStorage1 />} />
          <Route path="coldstorage2/exit" element={<ExitSColdStorage2 />} />
          <Route path="coldstorage3/exit" element={<ExitSColdStorage3 />} />
          <Route path="refrigerators/exit" element={<ExitSRefrigerators />} />
          <Route path="warehouse/exit" element={<ExitSWarehouse />} />
          <Route path="totems/exit" element={<ExitSTotems />} />
        </Route>

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </ActionFeedbackProvider>
  );
}

// Login wrapper
const LoginScreenWrapper = () => {
  const navigate = useNavigate();
  return <LoginScreen onLoginSuccess={() => navigate('/')} />;
};

export default App;
